<template>
  <main class="tw-z-10 -tw-mt-1">
    <!---<v-img :src="$utils.getRandomImage('geography')" height="300">
      <section class="tw-bg-gray-700 top-banner fill-height tw-flex tw-items-center">
        <v-container>
          <h1 class="text-h1 tw-text-white tw-mb-4">Find Station</h1>
          <the-station-search-input :stations="stations" />
        </v-container>
      </section>
    </v-img>--->
    <v-container>
      <h1 style="font-size:22px;"><strong>Station locations and site descriptions </strong></h1><br>
      <p style="font-size:20px;">The IWBN captures long-term trends for meteorology, soil moisture, and groundwater level. Therefore, locating monitoring sites consider landscape properties and environmental complexities that impact each hydrologic component. These complexities include obstacles that affect measurements of wind speed and solar radiation, vegetation variability that might influence soil-water dynamics, and groundwater pumping from nearby wells that can alter natural trends in groundwater levels. Monitoring sites are named according to the cardinal direction relative to the nearest incorporated city or town, and the sequence of monitoring initiation in the case of multiple nearby sites.</p>
      <page-title-sub>Station List</page-title-sub>
      <the-station-table :stations="stations" />
    </v-container>
  </main>
</template>

<script>
import PageTitleSub from '@/components/common/PageSubTitle'
import TheStationTable from '@/components/pages/station/TheStationTable'
// import TheStationSearchInput from '@/components/pages/station/TheStationSearchInput'
export default {
  name: 'station',
  layout: 'white',
  async created () {
    this.stations = await this.$api.station.index()
  },
  // components: { TheStationSearchInput, TheStationTable, PageTitleSub },
  components: { TheStationTable, PageTitleSub },
  data () {
    return {
      stations: []
    }
  }
}
</script>

<style lang="scss" scoped>
  .top-banner {
    --bg-opacity: 0.6 !important;
  }
</style>
